import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface AccordionItemProps {
  title: string;
  content?: string;
  isOpen: boolean;
  onClick: () => void;
}
export function AccordionItem({
  title,
  content,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border border-gray-200 rounded-lg mb-2 overflow-hidden bg-white shadow-sm" data-id="element-85">
      <button className="w-full px-4 py-3 text-left flex justify-between items-center font-semibold text-gray-800 hover:bg-gray-50 transition-colors" onClick={onClick} data-id="element-86">
        <span className="flex-1 pr-4" data-id="element-87">{title}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-blue-600 flex-shrink-0" data-id="element-88" /> : <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-89" />}
      </button>
      <AnimatePresence data-id="element-90">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2
      }} data-id="element-91">
            <div className="px-4 py-3 bg-gray-50 text-gray-600 border-t border-gray-100" data-id="element-92">
              {content || "Contenuto esclusivo disponibile all'interno del programma."}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
interface AccordionProps {
  items: {
    title: string;
    content?: string;
  }[];
}
export function Accordion({
  items
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="w-full max-w-2xl mx-auto" data-id="element-93">
      {items.map((item, index) => <AccordionItem key={index} title={item.title} content={item.content} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-94" />)}
    </div>;
}